export interface FilterOption {
    value: string | number;
    label: string;
}

// Cadastros auxiliares (id/descrição) como opções de seleção
export function lookupOptions(items: { id: number; description?: string }[]): FilterOption[] {
    return items.map((item) => ({ value: item.id, label: item.description || '' }));
}

// Filtro booleano opcional: '' (todos), 'true' ou 'false'
export function booleanFilterValue(value?: boolean): string {
    return value === undefined ? '' : String(value);
}

export function parseBooleanFilter(value: string): boolean | undefined {
    return value === '' ? undefined : value === 'true';
}

export function parseIdFilter(value: unknown): number | undefined {
    return value === '' || value === undefined || value === null ? undefined : Number(value);
}

export const PUBLICATION_STATUS_OPTIONS: FilterOption[] = [{ value: 'true', label: 'Publicada' }, { value: 'false', label: 'Rascunho' }];
